import { render, staticRenderFns } from "./FiltersPurchases.vue?vue&type=template&id=214dcc5a&"
import script from "./FiltersPurchases.vue?vue&type=script&lang=js&"
export * from "./FiltersPurchases.vue?vue&type=script&lang=js&"
import style0 from "./FiltersPurchases.vue?vue&type=style&index=0&id=214dcc5a&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports